import React from 'react';
import { Input, Select, InputNumber } from 'antd';
import style from './ScoreInterval.module.scss';
import {
    PlusCircleOutlined,
    DeleteOutlined,
} from '@ant-design/icons';

const Option = Select.Option;
const { TextArea } = Input;

const MAX_INTERVAL_NUMBER = 6;
const MIN_INTERVAL_NUMBER = 2;
const MIN_INTERVAL_NUMBER_CREATE = 4;

export default class ScoreInterval extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            intervalNumber: props.isCreate ? MIN_INTERVAL_NUMBER_CREATE : MIN_INTERVAL_NUMBER,
        };
    }

    addIntervalNumber = renderIntervalNumber => {
        this.setState({
            intervalNumber: renderIntervalNumber + 1,
        });
    }

    deleteInterval = (displayIndex, renderIntervalNumber) => {
        const { deleteIntervalRow = () => { } } = this.props;
        deleteIntervalRow(displayIndex);
        this.setState({
            intervalNumber: Math.max(renderIntervalNumber - 1, MIN_INTERVAL_NUMBER),
        });
    }

    render() {
        const { intervalNumber } = this.state;
        const { score_details, intervalValueOnChange = () => { }, scoreStdValueOnChange = () => { }, remark, remarkOnChange = () => { } } = this.props;
        const { dev_intervals = [] } = score_details;
        const intervalText = (dev_interval = [], index) => {
            const [min, max] = dev_interval;
            const { std_value = 0 } = score_details;
            const RoundFunc = num => parseFloat(parseFloat(num).toFixed(12));
            if (index === 0 && max !== undefined) return `${RoundFunc(std_value - max)} - ${RoundFunc(std_value + max)}`;
            if (index === 5 && min !== undefined) return `<${RoundFunc(std_value - min)}或 >${RoundFunc(std_value + min)}`;
            if (min !== undefined && max !== undefined) {
                if (min == max) return `${std_value} — ${std_value}`;
                return `${RoundFunc(std_value - max)} - ${RoundFunc(std_value + max)}`;
            }
            return '';
        };
        const propIntervalNumber = dev_intervals
            .filter(([v1, v2, v3] = []) => !!v1 || !!v2 || !!v3)
            .length;
        const renderIntervalNumber = Math.max(intervalNumber, propIntervalNumber);
        return (
            <div className={"score1_wrapper" + " " + style["score_interval_wrapper"]}>
                <div className="title">指标积分规则：</div>
                <div className="row_wrapper">
                    <div className="title">指标标准值：</div>
                    <InputNumber value={score_details.std_value || 0} onChange={scoreStdValueOnChange} style={{ width: 80 }} />
                </div>
                <table
                    className="content_table"
                >
                    <thead>
                        <tr>
                            <th>序号</th>
                            <th>原始得分</th>
                            <th>偏差范围</th>
                            <th>指标范围</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {
                            Array(renderIntervalNumber)
                                .fill(0)
                                .map((item, index) => {
                                    const displayIndex = index === renderIntervalNumber - 1 ? MAX_INTERVAL_NUMBER - 1 : index;
                                    const curInterval = dev_intervals[displayIndex] || [];
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                                <InputNumber value={curInterval[2] || 0} onChange={v => intervalValueOnChange(v, displayIndex, 2)} style={{ width: 80 }} />
                                            </td>
                                            <td style={{ width: 180 }}>
                                                <div
                                                    className="range_td"
                                                >
                                                    {
                                                        [0, MAX_INTERVAL_NUMBER - 1].indexOf(displayIndex) > -1 ?
                                                            <div className="min_max_block">{displayIndex === 0 ? '<' : '≥'}</div>
                                                            : <InputNumber min={0} value={curInterval[0] || 0} onChange={v => intervalValueOnChange(v, displayIndex, 0)} style={{ width: 80 }} />
                                                    }
                                                    <InputNumber min={0} value={curInterval[displayIndex === MAX_INTERVAL_NUMBER - 1 ? 0 : 1] || 0} onChange={v => intervalValueOnChange(v, displayIndex, displayIndex === MAX_INTERVAL_NUMBER - 1 ? 0 : 1)} style={{ width: 80 }} />
                                                </div>
                                            </td>
                                            <td>{intervalText(dev_intervals[displayIndex], displayIndex)}</td>
                                            <td>
                                                {
                                                    (index !== 0 && index !== renderIntervalNumber - 1) && (
                                                        <DeleteOutlined
                                                            style={{ fontSize: 20 }}
                                                            onClick={() => this.deleteInterval(displayIndex, renderIntervalNumber)}
                                                        />
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    );
                                })
                        }
                        {
                            renderIntervalNumber < MAX_INTERVAL_NUMBER && (
                                <tr>
                                    <td>
                                        <PlusCircleOutlined
                                            style={{ fontSize: 20, color: 'blue' }}
                                            onClick={() => this.addIntervalNumber(renderIntervalNumber)}
                                        />
                                    </td>
                                    <td colSpan="4" />
                                </tr>
                            )
                        }
                    </tbody>
                </table>
                <div className="row_wrapper">
                    <div className="title" style={{ alignSelf: 'flex-start' }}>备注：</div>
                    <TextArea rows={4} value={remark} onChange={e => remarkOnChange(e.target.value)} />
                </div>
            </div >
        );
    }
}